import React, { useState, useEffect, useRef } from 'react'

import { Map, View, Feature } from 'ol'
import { Polygon } from 'ol/geom'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import TileWMS from 'ol/source/TileWMS'
import 'ol/ol.css'
import VectorSource from 'ol/source/Vector'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'

import { BoundingBox } from '../dataStructures'

export const GeolocationMap = ({ boundingBoxes }: {boundingBoxes: BoundingBox[]}) => {
  const [map, setMap] = useState<Map>()
  const mapRef = useRef<Map>()
  mapRef.current = map

  useEffect(() => {
    const initialMap = new Map({
      layers: [new TileLayer({
        source: new TileWMS({
          url: 'https://wms.gebco.net/mapserv',
          params: {
            LAYERS: 'gebco_latest',
            FORMAT: 'image/png'
          },
          transition: 0,
          wrapX: true
        })
      }
      ),
      getDataLayer(boundingBoxes)
      ],
      view: new View({
        center: [0, 0],
        zoom: 0,
        projection: 'EPSG:4326'
      })
    })

    setMap(initialMap)
  }, [])

  useEffect(
    () => {
      map?.setTarget('geolocations-map')
      map?.getView().fit(getDataExtent(boundingBoxes))
    }, [map]
  )

  function getDataLayer (boundingBoxes: BoundingBox[]) {
    const features = []

    for (const bb of boundingBoxes) {
      const coordinates = [
        [bb.westCorner, bb.northCorner],
        [bb.eastCorner, bb.northCorner],
        [bb.eastCorner, bb.southCorner],
        [bb.westCorner, bb.southCorner]
      ]
      const poly = new Polygon([coordinates])
      const feat = new Feature({
        geometry: poly,
        name: 'box'
      })
      const stroke = new Stroke({
        color: 'red',
        width: 2
      })
      const style = new Style()
      style.setStroke(stroke)
      feat.setStyle(style)
      features.push(feat)
    }
    const source = new VectorSource({
      features
    })
    const layer = new VectorLayer({
      source
    })
    return layer
  }

  function getDataExtent (boundingBoxes: BoundingBox[]) {
    let westCorner = 10000
    let eastCorner = -10000
    let northCorner = -10000
    let southCorner = 10000

    for (const bb of boundingBoxes) {
      if ((bb.westCorner) < westCorner) {
        westCorner = bb.westCorner
      }
      if (bb.northCorner > northCorner) {
        northCorner = bb.northCorner
      }
      if ((bb.eastCorner) > eastCorner) {
        eastCorner = bb.eastCorner
      }
      if (bb.southCorner < southCorner) {
        southCorner = bb.southCorner
      }
    }
    return [westCorner - 5, southCorner - 5, eastCorner + 5, northCorner + 5]
  }

  return (
    <div id='geolocations-map' className="geolocations-map" />
  )
}
